<template>
	<div class="hairlist">
		<div class="nav-bar">
			<el-tabs v-model="achievementList" type="card" @tab-click="handleClick">
				<el-tab-pane label="发型师提成" name="one">
					<yeji></yeji>
				</el-tab-pane>
				<el-tab-pane label="发型师业绩" name="first">
					<achievement-list></achievement-list>
				</el-tab-pane>
				<el-tab-pane label="考核管理" name="second" :lazy="true">
					<achievement-setting></achievement-setting>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
	import yeji from './achievement/workerYeJi.vue'
	import achievementList from './achievement/achievementList.vue'
	import achievementSetting from './achievement/achievementSetting'

	export default {
		components: {
			yeji,
			achievementList,
			achievementSetting,
		},
		data() {
			return {
				achievementList: "one",
			};
		},
		methods: {
			handleClick() {

			}
		},
	};
</script>

<style>

</style>